var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningRoundFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 14 14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.75 7a6.25 6.25 0 1 1 12.5 0A6.25 6.25 0 0 1 .75 7Zm5 .5a1.25 1.25 0 0 0 2.5 0V3.75a1.25 1.25 0 0 0-2.5 0V7.5ZM7 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningRoundFilled);
export default ForwardRef;